
export function noOp() {
    return {type: 'NO-OP'};
};


/***************************************/
/********** HASH DEMO ACTIONS **********/
/***************************************/

export function changeInput(value) {
    return {
        type: 'HASH-INPUT-CHANGE',
        value,
    };
};

export function changeHashType(newType) {
    return {
        type: 'HASH-TYPE-CHANGE',
        newType,
    };
};

export function changeOutputType(newType) {
    return {
        type: 'HASH-OUTPUT-TYPE-CHANGE',
        newType,
    };
};

export function selectedFile(fileContents) {
    return {
        type: 'HASH-INPUT-FILE-CHANGE',
        contents: fileContents,
    };
};


/**********************************************/
/********** MERKLE TREE DEMO ACTIONS **********/
/**********************************************/

export function stageMerkleFiles(fileList) {
    return {
        type: 'MERKLE-STAGE-FILES',
        fileList,
    };
};

export function stageMerkleText(text) {
    return {
        type: 'MERKLE-STAGE-TEXT',
        text,
    };
};

export function addMerkleFiles() {
    return {
        type: 'MERKLE-ADD-FILES',
    };
};

export function updateMerkleFiles(files) {
    return {
        type: 'MERKLE-UPDATE-FILES',
        files,
    };
};

export function addMerkleText(text) {
    if( text ) {
        return {
            type: 'MERKLE-ADD-TEXT',
            text,
        };
    }
    return {
        type: 'MERKLE-ADD-TEXT',
    };
};

export function updateMerkleTree(tree) {
    return {
        type: 'MERKLE-UPDATE-TREE',
        tree,
    };
};

export function viewMerkleInput(node) {
    return {
        type: 'MERKLE-VIEW-INPUT',
        node,
    };
};

export function removeMerkleInput(which) {
    return {
        type: 'MERKLE-REMOVE-INPUT',
        which,
    };
};


/**********************************************/
/********** TRANSACTION DEMO ACTIONS **********/
/**********************************************/

export function transactionInitialize(data) {
    return {
        type: 'TXNS-INIT',
        data,
    };
};

export function transactionToggleInput(utxoId) {
    return {
        type: 'TXNS-TOGGLE-INPUT',
        utxoId,
    };
};

export function transactionToggleKey(keyName) {
    return {
        type: 'TXNS-TOGGLE-KEY',
        keyName,
    };
};

export function transactionUpdatePreparedOutput(values) {
    return {
        type: 'TXNS-PREPARE-OUTPUT',
        ...values,
    };
};

export function transactionAddOutput() {
    return {
        type: 'TXNS-ADD-OUTPUT',
    };
};

export function transactionRemoveOutput(index) {
    return {
        type: 'TXNS-REMOVE-OUTPUT',
        index,
    };
};


/*********************************************/
/********** PUBLIC KEY DEMO ACTIONS **********/
/*********************************************/

export function pubKeyEditSeed(seed) {
    return {
        type: 'PUBKEY-EDIT-SEED',
        seed,
    };
};

export function pubKeyGenerateSeed() {
    return {
        type: 'PUBKEY-GENERATE-SEED',
    };
};

export function pubKeyGeneratePrivateKey() {
    return {
        type: 'PUBKEY-GENERATE-PRIVATE-KEY',
    };
};

export function pubKeyToggleWif() {
    return {
        type: 'PUBKEY-TOGGLE-WIF',
    };
};

export function pubKeyGeneratePublicKey() {
    return {
        type: 'PUBKEY-GENERATE-PUBLIC-KEY',
    };
};

export function pubKeyGeneratePublicAddress() {
    return {
        type: 'PUBKEY-GENERATE-PUBLIC-ADDRESS',
    };
};

export function pubKeyReset() {
    return {
        type: 'PUBKEY-RESET',
    };
};


/******************************************/
/********** BLOCK MINING ACTIONS **********/
/******************************************/


export function miningEditData(content) {
    return {
        type: 'MINING-EDIT-DATA',
        content,
    };
};
export function miningAdjustDifficulty(level) {
    return {
        type: 'MINING-ADJUST-DIFFICULTY',
        level,
    };
};
export function miningSetNonce(value) {
    return {
        type: 'MINING-SET-NONCE',
        value,
    };
};
export function miningAutoToggle() {
    return {
        type: 'MINING-AUTO-TOGGLE',
    };
};
export function miningBackground() {
    return {
        type: 'MINING-BACKGROUND-START',
    };
};
export function miningBackgroundDone(nonce) {
    return {
        type: 'MINING-BACKGROUND-DONE',
        nonce,
    };
};



// WEBPACK FOOTER //
// ./src/actions.js